import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { chooseWallpaper, getObject, setObject, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';


class CAFrameName extends React.Component {
    state = {

        headers: [
            // { key: 'image', type: 'ProfileImageInput', theme: 'transparent', information: { placeholder: '{{lang}}ca.image', placeHolderImage: '', inputClass: 'none', required: false, cropper: true, ratio: '1:1', single: true } },
            // { key: 'name', type: 'TextInput', information: { label: '{{lang}}ca.name', placeholder: '{{lang}}ca.name', required: true } },
            // { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}ca.description', placeholder: '{{lang}}ca.write the description', required: false } }

            { type: 'TextInput', key: this.props?.customHeaderKey ?? 'name', information: { placeholder: '{{lang}}Frame name', required: true }, },

        ]
    }

    componentDidMount() {

        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                'title': this.props.isCreateFrame ? translate("Frame name") : translate("Create Frame"),
                isPortal: true,
                doNotshowNotification: true,

                topHeaderComponent: this.props.isCreateFrame ? this.topHeaderComponent : null,
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.isCreateFrame ? this.props.lastStage() : this.props.changePage('')
            })
        }
    }

    componentWillUnmount() {
    }



    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    isLoading={this.state.isLoadingData}
                    title='Next Step'
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>

        )
    }


    nextStage = () => {
        let data = this.form.getForm()

        if (data) {

            let name = getObject(data, (this.props?.customHeaderKey ?? 'name'))

            if (data.frames && data.frames[0]) {
                data.frames[0].name = name
            }

            if (this.props.secCustomHeaderKey) {
                setObject(data, this.props.secCustomHeaderKey, name)
            }

            console.log(data)

            this.props.setData(data, () => {
                this.props.continue(this.props.initStage ?? 'type')
            })
        }
    }


    formLiveChange = (data, init, key, value, extra, full) => {
        // console.log(full)

        // if (full) {
        //     let hub = { _id: full.value, fullname: full.title, image: full.image, username: full.description }
        //     this.props.setData(hub, null, 'hubInfo')
        //     // console.log(full)
        // }
    }


    render() {

        // console.log(this.props.initData)
        return (

            <div className=" w-100 h-100  position-relative" style={{ backgroundColor: '' }}>

                <div className='w-100 h-100 position-absolute overflow-hidden' >
                    <div className='animated-bg' style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(88, 86, 214, 0.1) 0%, rgba(245, 228, 255, 0) 100%)' }}></div>
                    {/* <div className='animated-bg' style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}></div> */}
                </div>

                <div className=' w-100 h-100 scroll-no-scrollbar'>
                    {/* <Responsive width={this.props.width} media={{ xs: "12", md: '12' }}> */}
                    <div className='px-5  w-100 flexc py-5  flex-column '>
                        <div className='w-100' style={{ maxWidth: 450 }}>
                            {/* <img src="/assets/icons/portals/Asset 2.svg" height={70} /> */}

                            {this.props.isCreateFrame ? (
                                <h2 className="mt-1 text-semibig mb-0 color-dark-blue-1 " >{translate('Name of frame')}</h2>
                            ) : (
                                <h2 className="mt-1 text-semibig mb-0 color-dark-blue-1 " >{translate('Create new collection')}</h2>

                            )}

                            <div style={{ maxWidth: 450 }}>
                                <p className="mt-1 text-small color-dark-blue-1 " >{translate('What is an applet? Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt iure mollitia illo et, id deleniti magnam necessitatibus. Expedita ad, numquam voluptatum autem atque dignissimos laboriosam. Culpa enim quod maxime asperiores.')}</p>
                            </div>

                            <div className='mt-3' >
                                <p className="mb-2 text-normal required text-semibold mb-0 color-dark-blue-1 " >{translate("Frame name")}</p>
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.initData} liveChange={this.formLiveChange} errors={this.state.errors} inputClass={'white-input with-shadow single-big text-bold color-dark-blue-1'} nopadding={true} />
                            </div>

                            {!this.props.isCreateFrame && (
                                <div className='mt-3 flexc position-relative' style={{ width: 'max-content' }}>
                                    <ButtonAnimated
                                        onClick={() => this.nextStage()}
                                        title={translate("ca.Let's Start")}
                                        icon={'/assets/icons/angle-right-white2.svg'}
                                        imgWidth={'25px'}
                                        bg='linear-gradient(90deg, rgb(64 168 199), rgb(90 86 251))'
                                        textColor='#fff'
                                    // className={'button-interactive-1'}
                                    // language={this.props.language}
                                    />


                                </div>
                            )}
                            {/* <button onClick={() => this.props.nextStage()} className='px-1 py-1 mt-3 flexcc' style={{ background: 'linear-gradient(to right, #FF9D5E, #FE6481)', borderRadius: 6, color: '#fff' }}>
                                    <p className='text-small text-semibold mld-3 mrd-3'>{translate("Let's Start")}</p>

                                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 6 }}>
                                        <img className='invert' src='/assets/icons/angle-right.svg' height={18} />
                                    </div>
                                </button> */}
                        </div>
                    </div>
                    {/* </Responsive> */}


                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "none", md: '4', lg: "6", xl: "6" }}>
                        <div className=' p-4 w-100 h-100 d-flex' >
                            <div className='px-4 py-4' style={{ backgroundColor: '#ffffffee', borderRadius: 8, flex: 1 }}>
                                <h2 className=" text-big mb-0" >{translate('Intro and Features')}</h2>
                                <p className="mt-1 text-small" >{translate('What is a hub? Lorem ipsum dolor sit amet consectetur, adipisicing elit. Incidunt iure mollitia illo et, id deleniti magnam necessitatibus. Expedita ad, numquam voluptatum autem atque dignissimos laboriosam. Culpa enim quod maxime asperiores.')}</p>
                            </div>
                        </div>
                    </Responsive> */}
                </div>

            </div>

        )
    }
}

export default CAFrameName;